export const expDetailsTemplateKeys = {
  personalTemplate: (expKey: string, projectId: string) =>
    ['experiment-details-personal-template', expKey, projectId] as const,
  projectTemplate: (viewId: string) =>
    ['experiment-details-project-template', viewId] as const,
  templateList: (projectId: string) =>
    ['experiment-details-template-list', projectId] as const,
  metricKeys: (experimentKeys: string[]) => [
    'metric-names-for-experiment-keys',
    { experimentKeys }
  ],
  personalTemplateProcessed: ['experiment-details-processed-personal-template']
};
